<template>
  <div id="idea-container">

    <h2><i class="fad fa-fw" :class="activeRoute.icon"></i> {{ activeRoute.title }}</h2>
    <p class="lead">
      {{ activeRoute.description }}
    </p>

    <router-link class="btn btn-primary mb-5" to="/ideas/add">Neue Idee erstellen</router-link>

    <TheorySwitchHint v-if="ideas && project.ideas.length > ideas.length" item="Ideen"></TheorySwitchHint>

    <IntroBanner v-if="!(ideas && ideas.length)" link="/ideas/add"></IntroBanner>

    <div v-if="ideas.length" class="row">
      <div v-for="(idea, index) in ideas" :id="'idea-' + index" class="col-sm-12 mb-4" :key="index">
        <Idea :idea="idea"></Idea>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Idea from "../components/Idea";
import IntroBanner from "@/components/IntroBanner";
import TheorySwitchHint from "@/components/TheorySwitchHint";

export default {
  name: 'Ideas',
  components: {
    TheorySwitchHint,
    IntroBanner,
    Idea
  },
  data() {
    return {
    }
  },
  computed: {
    ideas() {
      return this.project.ideas
          .filter(idea => !this.activeTheoryId || idea.theoryId === this.activeTheoryId)
          .map(idea => {
        idea.node = this.project.netNodes.find(n => n.url === idea.nodeUrl);

        if (idea.scores) {
          let scores = idea.scores;
          if (Object.values(scores).filter(x => x === undefined).length === 0) {
            let effort = parseInt(scores.frontendEffort) + parseInt(scores.backendEffort) + parseInt(scores.conceptEffort) + parseInt(scores.otherEffort);
            let impact = parseInt(scores.visualContrast) + parseInt(scores.behaviourContrast) + parseInt(scores.patternsImpact) + parseInt(scores.trafficImpact);

            idea.effort = effort < 8 ? 'Low' : effort > 16 ? 'High' : 'Medium';
            idea.impact = impact < 8 ? 'Low' : impact > 16 ? 'High' : 'Medium';
            idea.scoring = Math.round((impact - effort) * 3.125 + 50);
          }
        } else {
          idea.scoring = "N/A";
        }
        return idea;
      });
    },
  },
  methods: {
  }
}
</script>
